import React from 'react';
import { Link } from 'react-router-dom';

const lineStyle = {
  width: 2,
  backgroundColor: '#EBECED',
};


const Home = () => (
  <div className="mw8 pa3 tc">
    <h2 className="dark-blue-gray mw8  f-subheadline-ns f2 fw9 tracked-tight mt0 mb5 lh-tight">Which metrics should your team track?</h2>
    <h3 className="mw7 center fw5 gecko-green f3-ns f3  lh-title mb3">Trying to identify the most important metrics to track progress?</h3>
    <h3 className="mw7 center light-blue-gray fw3 f3-ns f3 mt0 lh-title mb4">That’s why we created this handy SaaS Metrics Generator. We’ll curate the most important metrics for you to track in just 3 clicks!</h3>
    <div className="h3-ns h2 center br-pill" style={lineStyle}/>
    <Link to="/questions" className="mt4 dib ph5-ns ph4 bg-gecko-green white no-underline fw7 f3-ns f5 br-pill center grow pv3">Start</Link>
  </div>
);

export default Home;



// WEBPACK FOOTER //
// ./src/components/home/Home.js